module.exports = __webpack_public_path__ + "static/media/pic_banner_educators.4aa3015d.jpg";